import React, { useState, ChangeEvent } from 'react';
import TextInput from '../../../common/components/TextInput';
import { EMAIL_REGEX } from '../../../common/constants/validations';
import './UserEditor.pcss';

type FieldType = 'email' | 'text';

type Props = {
  fieldName: string;
  fieldType: FieldType;
  value: string;
  canEdit?: boolean;
  onChangeUser?: (fieldName: string, fieldValue: string) => void;
};

const isValid = (value: string, fieldType: FieldType): boolean => {
  switch (fieldType) {
    case 'email':
      return !!value.match(EMAIL_REGEX);
    default:
      return true;
  }
};

export const UserFieldEditor = ({
  fieldName,
  value,
  canEdit,
  fieldType,
  onChangeUser,
}: Props) => {
  const [localValue, setLocalValue] = useState(value);
  const [errorMessage, setErrorMessage] = useState('');

  const onValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    const nextValue = e.target.value;

    setLocalValue(nextValue);
    if (isValid(nextValue, fieldType)) {
      setErrorMessage('');
      if (onChangeUser) onChangeUser(fieldType, nextValue);
    } else {
      setErrorMessage(`Please enter a valid ${fieldType}`);
    }
  };

  return (
    <div className="user-editor-component__field-container">
      <div className="user-editor-component__field-title sub-title">
        {fieldName}
      </div>
      <div className="user-editor-component__field">
        {canEdit ? (
          <div>
            <TextInput
              value={localValue}
              onChange={onValueChange}
              className="user-editor-component__input"
            />
            <div className="user-editor-component__field-error">
              {errorMessage}
            </div>
          </div>
        ) : (
          localValue
        )}
      </div>
    </div>
  );
};
